module.exports = __webpack_public_path__ + "static/udhyam-26676969cd55b658022d6d29301a731d.png";